import { create } from 'zustand';
import type { Me } from '../lib/types';

interface AuthState {
  user: Me | null;
  ready: boolean;
  setUser: (user: Me | null) => void;
  setReady: (ready: boolean) => void;
  clear: () => void;
}

export const useAuthStore = create<AuthState>(set => ({
  user: null,
  ready: false,
  setUser: user => set({ user }),
  setReady: ready => set({ ready }),
  clear: () => set({ user: null, ready: false }),
}));
